import React, {Component} from 'react';
import axios from 'axios';
import {connect} from "react-redux";
import css from './PhotoPack.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faPlus } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { fetchS3Photos, uploadSinglePhoto } from '../../utils/awsHelper';

/**
 * @class
 *
 * PhotoPack page.
 */
const MPUPhotoPack = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();
    opportunityId = this.props.opportunityId;
    sessId = this.props.sessId;
    type = this.props.type;
    s3;
    username = this.props.user.name;
    SF_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";

    postRequestOpp = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Company__c",
            "Substantial__c",
            "Substantial__r.Name",
            "Ground_Mount__c",
            "Days_to_Clawback__c",
            "Site_Visits__c",
            "Location__r.Name"
        ],
        "where": {
            "Id": this.opportunityId
        }
    };

    postRequestSession = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Field_Job__c",
            "Assigned_Crew__r.Work_Phone_Number__c"
        ],
        "where": {
            "Id": this.sessId
        }
    };

    postRequestWorkOrder = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Assigned_Field_Team__c", 
            "Assigned_Field_Team__r.Tech_1__c",
            "Assigned_Field_Team__r.Tech_1__r.Work_Phone_Number__c",
            "Review_Submitted__c",
            "Number_of_Days__c"
        ],
        "where": {
            "Id": this.sessId
        }
    };

    state = {
        preview: false,
        previewPic: {},
        previewPics: [],
        filesToUpload: [],
        uploading: false,
        fileUploadCounter: 0,
        errorMessage: '',
        opp: {},
        session: {},
        slackResponse: '',
        sendingToSlack: false,
        tier3rtr: false,
        isPast6PM: false,
        isWorkOrder: false,

        ElectricalStandBack: {},
        ElectricalStandBackError: false,

        ElectricalStandBackArray: [],

        MSPPanelLabels: {},
        MSPPanelLabelsError: false,

        MSPWiring: {},
        MSPWiringError: false,

        MSPWiringArray: [],

        MainBreaker: {},
        MainBreakerError: false,

        SolarBreaker: {},
        SolarBreakerError: false,

        BatteryBreaker: {},
        BatteryBreakerError: false,

        MSPLabeledDeadfront: {},
        MSPLabeledDeadfrontError: false,

        UFERGround: {},
        UFERGroundError: false,

        ConsumptionCT: {},
        ConsumptionCTError: false,

        ConsumptionCTArray: [],

        CommissioningScreenshot: {},
        CommissioningScreenshotError: false,

        CommissioningScreenshotArray: [],

        StandBackSubPanel: {},
        StandBackSubPanelError: false,

        SubPanelBusBarRating:{},
        SubPanelBusBarRatingError: false,

        SubPanelMainBreaker:{},
        SubPanelMainBreakerError: false,

        SubPanelBreakers:{},
        SubPanelBreakersError: false,

        SubPanelDeadfrontLabeled: {},
        SubPanelDeadfrontLabeledError: false,

        SignedMeterRelease: {},
        SignedMeterReleaseError: false,

        OtherPhotos: {},
        OtherPhotosError: false,

        OtherPhotosArray: [],

        CADChanges: {},
        CADChangesError: false,
        CADChangesArray: [],

        WireSize: {},
        WireSizeError: false
    }

    // ---------- life cycle methods: ----------
    async componentDidMount() {
        window.scrollTo(0, 0);

        fetchS3Photos({
            recordId: this.opportunityId,
            type: '/' + this.type,
            process: 'getDocs',
            existingState: this.state,
            source: this.source
        })
        .then(newState => {
            this.setState(newState);
        })
        .catch(err => {
            console.error('AWS S3 fetch error:', err);
            this.setState({ errorMessage: err.message });
        });

        const now = new Date();
        const pstTime = moment(now, "America/Los_Angeles");
        if (pstTime.hour() >= 18) {
            this.setState({ isPast6PM: true });
        }

        await this.getOpp();

        const isWorkOrder = this.sessId.startsWith('a0j');
        this.setState({ isWorkOrder });

        if (isWorkOrder) {
            await this.getWorkOrder();
        } else {
            await this.getSession();
        }
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    getOpp = async() => {
        axios.post(
            '/sf/opportunity/findNo',
            this.postRequestOpp,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];
                this.setState({opp: data});

                if((data.Days_to_Clawback__c !== null && data.Days_to_Clawback__c < 30) || data.Site_Visits__c >= 6) {
                    this.setState({tier3rtr: true});
                }
            })
            .catch(err => console.log('POST Error Opp:\n', err));
    };

    getSession = async() => {
        axios.post(
            '/sf/schedulable/findNo',
            this.postRequestSession,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];

                this.setState({session: data});
            })
            .catch(err => console.log('POST Error Session:\n', err));
    };

    getWorkOrder = async() => {
        axios.post(
            '/sf/WorkOrder/findNo',
            this.postRequestWorkOrder,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];

                this.setState({session: data});
            })
            .catch(err => console.log('POST Error Session:\n', err));
    }

    capturePhoto = async(file, stateName, stateNameError) => {
        if (!file || this.state.uploading) return;
                
        try {
            await uploadSinglePhoto({
                file,
                stateName,
                stateNameError,
                username: this.username,
                opportunityId: this.opportunityId,
                type: this.type,
                setState: this.setState.bind(this),
                source: this.source
            });
        } catch(err){
            console.log(err)
        }
    };

    previewImage = (e) => {
        let img = e;
        this.setState({previewPic: img, preview:true});
    };

    addAnotherPic = (array, fileName, displayName) => {
        let picNumber = this.state[array].length + 1;
        let stateName = fileName + picNumber.toString()
        this.setState({
            [array]: [...this.state[array], stateName],
            [stateName] : {}
        })
    };

    sendToSlack = () => {
        this.setState({sendingToSlack: true});

        let message = 'MPU Photos Review for: <https://v3electric.my.site.com/frontendOps/s/detail/' +  this.state.opp.Id + '|' +  this.state.opp.Name +'>\n' +
            'Field Tech: ' + this.props.user.name + '\n' +
            'Photo Pack Page: <https://v3electric.my.site.com/frontendOps/s/sfdcpage/%2Fapex%2FPhotoPackOppS3%3F%26id%3D' + this.state.opp.Id + '|Photo Pack>\n' +
            'Work Order: <https://v3electric.my.site.com/frontendOps/s/detail/' + this.state.session.Id + '|' +  this.state.session.Name +'>\n' +
            'Substantial: <https://v3electric.my.site.com/frontendOps/s/detail/' + this.state.opp.Substantial__c + '|' +  this.state.opp.Substantial__r.Name +'>\n' +
            'Financier: ' + this.state.opp.Company__c + '\n' +
            'Location: ' + this.state.opp.Location__r.Name + '\n' +
            'Number of Days: ' + this.state.session.Number_of_Days__c;

        // test-api channel id C06JN84MGFM
        // tier 1 rtr id: C07UMTF64TE
        // tier 2 rtr id: C07UGHTQ7M3
        // tier 3 rtr id: C07V87JGTFS

        let channelId = '';

        if((this.state.opp.Days_to_Clawback__c > 30 || this.state.opp.Days_to_Clawback__c === null) && this.state.opp.Site_Visits__c < 6) {
            channelId = 'C07UGHTQ7M3'; // tier 2
        } else if((this.state.opp.Days_to_Clawback__c !== null && this.state.opp.Days_to_Clawback__c < 30) || this.state.opp.Site_Visits__c >= 6) {
            channelId = 'C07V87JGTFS'; // tier 3
            if(this.state.isWorkOrder){
                message = message + '\nTechs Work Phone Number: ' + this.state.session.Assigned_Field_Team__r.Tech_1__r.Work_Phone_Number__c;
            } else {
                message = message + '\nTechs Work Phone Number: ' + this.state.session.Assigned_Crew__r.Work_Phone_Number__c;
            }
        } else {
            channelId = 'C07UMTF64TE'; // default to tier 1
        }

        let payload = {
            "channel": channelId,
            "text": message
        };

        axios.post(
            '/slackMessage', 
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({slackResponse: 'Notification sent to Slack successfully', sendingToSlack: false});

                let subPayload = {
                    Id: this.state.opp.Substantial__c,
                    MPU_Review_SubmittedDT__c: moment()
                };

                axios.put(
                    '/sf/substantial/update',
                    subPayload,
                    {
                        cancelToken: this.source.token
                    }).then((res) => {
                        
                    })
                    .catch(err => console.log('PUT Error updating substantial:\n', err))

                // Review Submitted on WO is used for reporting on when field team initially requested RTR.
                if(this.state.isWorkOrder && !this.state.session.Review_Submitted__c){
                    let woPayload = {
                        Id: this.sessId,
                        Review_Submitted__c: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
                    };

                    axios.put(
                        '/sf/WorkOrder/update', 
                        woPayload, 
                        {
                            cancelToken: this.source.token
                        })
                        .catch(err => console.log('PUT Error Updating WO on RTR Request:\n', err));
                }

                setTimeout(() => {
                    this.setState({slackResponse: ''});
                }, 3000);
            })
            .catch(err => {
                console.log('POST Error Sending Slack Message:\n', err);
                this.setState({slackResponse: 'Failed to send to Slack: ' + err.message, sendingToSlack: false});
            });
    };

    render() {
        return (
            <div className={css.PhotoPack}>
                <h1 className='pb-3'>{this.type} Photo Pack</h1>
                <h2 className='text-white pb-3'>Please Ensure HEIC is turned off as the format isn't readily sharable</h2>
                <h2 className={this.state.errorMessage !== '' ? 'text-error' : 'd-none'}>Error: {this.state.errorMessage}</h2>
                
                {
                    this.state.preview ? 
                    <div>
                        <div>
                            <img className={css.PhotoPack__PreviewImg} src={this.state.previewPic} alt="Preview of upload" />
                        </div>
                        <div className='pt-3'>
                            <button className='btn btn-primary' onClick={() => this.setState({preview: false, previewPic: {}})}>Close Preview</button>
                        </div>
                    </div>

                    :

                    <div>
                        {/* Slack div to send messages */}
                        <div className='py-3'>
                            <button className='btn btn-primary' disabled={this.state.sendingToSlack} onClick={() => this.sendToSlack()}>Notify Office for Review</button>
                        </div>
                        <div className={this.state.slackResponse !== '' ? 'py-3' : 'd-none'}>
                            <p className='text-white'>{this.state.slackResponse}</p>
                        </div>
                        <div className={this.state.sendingToSlack ? 'py-3' : 'd-none'}>
                            <div className={css.PhotoPack__Loader}></div>
                        </div>
                        {
                            this.state.tier3rtr ? 
                                this.state.isPast6PM ? 
                                <h2 className='text-white pb-3'>This is a Tier 3 project. Reviewers are unavailable at this time. Please be prepared to have a phone review tomorrow morning.</h2>
                                :
                                <h2 className='text-white pb-3'>This is a Tier 3 project. Please sit tight until you receive a call from the RTR team to conduct the review.</h2>
                                :
                                <></>
                        }

                        <table>
                            <tbody>

                                {/* Electrical Stand Back Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.ElectricalStandBack).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Electrical Stand Back: Photo of all electrical equipment and conduit path from roof to the MSP. Take from multiple angles </div>
                                            :
                                            this.state.ElectricalStandBackError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Electrical Stand Back: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.ElectricalStandBack)}><FontAwesomeIcon icon={faCircle} /> Electrical Stand Back: Photo of all electrical equipment and conduit path from roof to the MSP. Take from multiple angles </button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="ElectricalStandBack" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="ElectricalStandBack" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'ElectricalStandBack', 'ElectricalStandBackError')} /></td>
                                    <td className="w-25"><label for="ElectricalStandBackUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="ElectricalStandBackUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'ElectricalStandBack', 'ElectricalStandBackError')}/></td>
                                </tr>

                                {/* Electrical Stand Back Array Photos */}
                                {
                                    this.state.ElectricalStandBackArray.length !== 0 ? 
                                    
                                    this.state.ElectricalStandBackArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Electrical Stand Back Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('ElectricalStandBackArray', 'ElectricalStandBack-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* MSP Panel Labels Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.MSPPanelLabels).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> MSP Panel Labels w/ Bus Ratings: Bus ratings must be legible and accurate to the plans. If no MSP label is available, the main breaker rating will be counted as the bus rating</div>
                                            :
                                            this.state.MSPPanelLabelsError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading MSP Panel Labels w/ Bus Ratings: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.MSPPanelLabels)}><FontAwesomeIcon icon={faCircle} /> MSP Panel Labels w/ Bus Ratings: Bus ratings must be legible and accurate to the plans. If no MSP label is available, the main breaker rating will be counted as the bus rating</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="MSPPanelLabels" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="MSPPanelLabels" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'MSPPanelLabels', 'MSPPanelLabelsError')} /></td>
                                    <td className="w-25"><label for="MSPPanelLabelsUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="MSPPanelLabelsUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'MSPPanelLabels', 'MSPPanelLabelsError')}/></td>
                                </tr>

                                {/* MSP Wiring Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.MSPWiring).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> MSP Wiring: Completed MSP wiring with all breakers, power blocks, main breaker installed.</div>
                                            :
                                            this.state.MSPWiringError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading MSP Wiring: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.MSPWiring)}><FontAwesomeIcon icon={faCircle} /> MSP Wiring: Completed MSP wiring with all breakers, power blocks, main breaker installed.</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="MSPWiring" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="MSPWiring" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'MSPWiring', 'MSPWiringError')} /></td>
                                    <td className="w-25"><label for="MSPWiringUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="MSPWiringUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'MSPWiring', 'MSPWiringError')}/></td>
                                </tr>

                                 {/* MSP Wiring Array Photos */}
                                 {
                                    this.state.MSPWiringArray.length !== 0 ? 
                                    
                                    this.state.MSPWiringArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another MSP Wiring Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('MSPWiringArray', 'MSPWiring-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Main Breaker Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.MainBreaker).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Main Breaker: Close up photo of main breaker with the rating clearly visible</div>
                                            :
                                            this.state.MainBreakerError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Main Breaker: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.MainBreaker)}><FontAwesomeIcon icon={faCircle} /> Main Breaker: Close up photo of main breaker with the rating clearly visible</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="MainBreaker" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="MainBreaker" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'MainBreaker', 'MainBreakerError')} /></td>
                                    <td className="w-25"><label for="MainBreakerUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="MainBreakerUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'MainBreaker', 'MainBreakerError')}/></td>
                                </tr>

                                {/* Solar Breaker Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.SolarBreaker).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Solar Breaker: Close up photo of the solar breaker (may be in main breaker or other sub panel)</div>
                                            :
                                            this.state.SolarBreakerError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Solar Breaker: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.SolarBreaker)}><FontAwesomeIcon icon={faCircle} /> Solar Breaker: Close up photo of the solar breaker (may be in main breaker or other sub panel)</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="SolarBreaker" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="SolarBreaker" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'SolarBreaker', 'SolarBreakerError')} /></td>
                                    <td className="w-25"><label for="SolarBreakerUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="SolarBreakerUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'SolarBreaker', 'SolarBreakerError')}/></td>
                                </tr>

                                {/* Battery Breaker Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.BatteryBreaker).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Battery Breaker (if applicable)</div>
                                            :
                                            this.state.BatteryBreakerError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Battery Breaker: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.SolarBreaker)}><FontAwesomeIcon icon={faCircle} /> Battery Breaker (if applicable)</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="BatteryBreaker" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="BatteryBreaker" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'BatteryBreaker', 'BatteryBreakerError')} /></td>
                                    <td className="w-25"><label for="BatteryBreakerUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="BatteryBreakerUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'BatteryBreaker', 'BatteryBreakerError')}/></td>
                                </tr>

                                {/* MSP Labeled Deadfront Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.MSPLabeledDeadfront).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> MSP Labeled Deadfront: All breakers must be labeled including any existing solar.</div>
                                            :
                                            this.state.MSPLabeledDeadfrontError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading MSP Labeled Deadfront: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.MSPLabeledDeadfront)}><FontAwesomeIcon icon={faCircle} /> MSP Labeled Deadfront: All breakers must be labeled including any existing solar.</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="MSPLabeledDeadfront" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="MSPLabeledDeadfront" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'MSPLabeledDeadfront', 'MSPLabeledDeadfrontError')} /></td>
                                    <td className="w-25"><label for="MSPLabeledDeadfrontUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="MSPLabeledDeadfrontUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'MSPLabeledDeadfront', 'MSPLabeledDeadfrontError')}/></td>
                                </tr>

                                {/* UFER Ground Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.UFERGround).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> UFER Ground: Irreversible crimp connecting ground wire to the main panel grounding</div>
                                            :
                                            this.state.UFERGroundError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading UFER Ground: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.UFERGround)}><FontAwesomeIcon icon={faCircle} /> UFER Ground: Irreversible crimp connecting ground wire to the main panel grounding</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="UFERGround" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="UFERGround" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'UFERGround', 'UFERGroundError')} /></td>
                                    <td className="w-25"><label for="UFERGroundUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="UFERGroundUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'UFERGround', 'UFERGroundError')}/></td>
                                </tr>

                                {/* Consumption CTs Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.ConsumptionCT).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Consumption CTs: When applicable</div>
                                            :
                                            this.state.ConsumptionCTError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Consumption CTs: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.ConsumptionCT)}><FontAwesomeIcon icon={faCircle} /> Consumption CTs: When applicable</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="ConsumptionCT" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="ConsumptionCT" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'ConsumptionCT', 'ConsumptionCTError')} /></td>
                                    <td className="w-25"><label for="ConsumptionCTUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="ConsumptionCTUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'ConsumptionCT', 'ConsumptionCTError')}/></td>
                                </tr>

                                {/* Consumption CTs Array Photos */}
                                {
                                    this.state.ConsumptionCTArray.length !== 0 ? 
                                    
                                    this.state.ConsumptionCTArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Consumption CT Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('ConsumptionCTArray', 'ConsumptionCT-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Commissioning Screenshot Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.CommissioningScreenshot).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Commissioning Screenshots: Must show all panels, S-OK Cellular and country set to Rule 21 240V. If CTs are not installed, the meter to inverter must be set to production only.</div>
                                            :
                                            this.state.CommissioningScreenshotError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Commissioning Screenshots: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.CommissioningScreenshot)}><FontAwesomeIcon icon={faCircle} /> Commissioning Screenshots: Must show all panels, S-OK Cellular and country set to Rule 21 240V. If CTs are not installed, the meter to inverter must be set to production only.</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="CommissioningScreenshot" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="CommissioningScreenshot" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'CommissioningScreenshot', 'CommissioningScreenshotError')} /></td>
                                    <td className="w-25"><label for="CommissioningScreenshotUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="CommissioningScreenshotUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'CommissioningScreenshot', 'CommissioningScreenshotError')}/></td>
                                </tr>

                                {/* Commissioning Screenshot Array Photos */}
                                {
                                    this.state.CommissioningScreenshotArray.length !== 0 ? 
                                    
                                    this.state.CommissioningScreenshotArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Commissioning Screenshot Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('CommissioningScreenshotArray', 'CommissioningScreenshot-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                 {/* Stand Back of Equipment Sub Panels Photos */}
                                 <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.StandBackSubPanel).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Stand Back of Equipment Sub Panels</div>
                                            :
                                            this.state.StandBackSubPanelError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Stand Back of Equipment Sub Panels: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.CommissioningScreenshot)}><FontAwesomeIcon icon={faCircle} /> Stand Back of Equipment Sub Panels</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="StandBackSubPanel" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="StandBackSubPanel" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'StandBackSubPanel', 'CommissioningScreenshotError')} /></td>
                                    <td className="w-25"><label for="StandBackSubPanelUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="StandBackSubPanelUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'StandBackSubPanel', 'StandBackSubPanelError')}/></td>
                                </tr>

                                {/* Sub Panel Bus Bar Rating Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.SubPanelBusBarRating).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Sub Panel Bus Bar Rating</div>
                                            :
                                            this.state.SubPanelBusBarRatingError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Sub Panel Bus Bar Rating: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.SubPanelBusBarRating)}><FontAwesomeIcon icon={faCircle} /> Sub Panel Bus Bar Rating</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="SubPanelBusBarRating" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="SubPanelBusBarRating" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'SubPanelBusBarRating', 'SubPanelBusBarRatingError')} /></td>
                                    <td className="w-25"><label for="SubPanelBusBarRatingUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="SubPanelBusBarRatingUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'SubPanelBusBarRating', 'SubPanelBusBarRatingError')}/></td>
                                </tr>

                                {/* Sub Panel Main Breaker Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.SubPanelMainBreaker).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Sub Panel Main Breaker</div>
                                            :
                                            this.state.SubPanelMainBreakerError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Sub Panel Main Breaker: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.SubPanelMainBreaker)}><FontAwesomeIcon icon={faCircle} /> Sub Panel Main Breaker</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="SubPanelMainBreaker" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="SubPanelMainBreaker" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'SubPanelMainBreaker', 'SubPanelMainBreakerError')} /></td>
                                    <td className="w-25"><label for="SubPanelMainBreakerUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="SubPanelMainBreakerUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'SubPanelMainBreaker', 'SubPanelMainBreakerError')}/></td>
                                </tr>

                                {/* Sub Panel Breakers Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.SubPanelBreakers).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Sub Panel Breakers</div>
                                            :
                                            this.state.SubPanelBreakersError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Sub Panel Breakers: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.SubPanelBreakers)}><FontAwesomeIcon icon={faCircle} /> Sub Panel Breakers</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="SubPanelBreakers" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="SubPanelBreakers" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'SubPanelBreakers', 'SubPanelBreakersError')} /></td>
                                    <td className="w-25"><label for="SubPanelBreakersUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="SubPanelBreakersUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'SubPanelBreakers', 'SubPanelBreakersError')}/></td>
                                </tr>

                                {/* Sub Panel Deadfront Labeled Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.SubPanelDeadfrontLabeled).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Sub Panel Deadfront Labeled</div>
                                            :
                                            this.state.SubPanelDeadfrontLabeledError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Sub Panel Deadfront Labeled: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.SubPanelDeadfrontLabeled)}><FontAwesomeIcon icon={faCircle} /> Sub Panel Deadfront Labeled</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="SubPanelDeadfrontLabeled" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="SubPanelDeadfrontLabeled" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'SubPanelDeadfrontLabeled', 'SubPanelDeadfrontLabeledError')} /></td>
                                    <td className="w-25"><label for="SubPanelDeadfrontLabeledUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="SubPanelDeadfrontLabeledUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'SubPanelDeadfrontLabeled', 'SubPanelDeadfrontLabeledError')}/></td>
                                </tr>

                                {/* Signed Meter Release Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.SignedMeterRelease).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Signed Meter Release</div>
                                            :
                                            this.state.SignedMeterReleaseError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Signed Meter Release: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.SignedMeterRelease)}><FontAwesomeIcon icon={faCircle} /> Signed Meter Release</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="SignedMeterRelease" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="SignedMeterRelease" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'SignedMeterRelease', 'SignedMeterReleaseError')} /></td>
                                    <td className="w-25"><label for="SignedMeterReleaseUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="SignedMeterReleaseUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'SignedMeterRelease', 'SignedMeterReleaseError')}/></td>
                                </tr>

                                {/* CADChanges Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.CADChanges).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> CAD Changes</div>
                                            :
                                            this.state.CADChangesError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading CAD Changes: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.CADChanges)}><FontAwesomeIcon icon={faCircle} /> CAD Changes</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="CADChanges" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="CADChanges" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'CADChanges', 'CADChangesError')} /></td>
                                    <td className="w-25"><label for="CADChangesUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="CADChangesUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'CADChanges', 'CADChangesError')}/></td>
                                </tr>

                                {/* CADChanges Array Photos */}
                                {
                                    this.state.CADChangesArray.length !== 0 ? 
                                    
                                    this.state.CADChangesArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another CAD Changes Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('CADChangesArray', 'CADChanges-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* WireSize Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.WireSize).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Wire Size</div>
                                            :
                                            this.state.WireSizeError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Wire Size: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.WireSize)}><FontAwesomeIcon icon={faCircle} /> Wire Size</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="WireSize" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="WireSize" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'WireSize', 'WireSizeError')} /></td>
                                    <td className="w-25"><label for="WireSizeUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="WireSizeUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'WireSize', 'WireSizeError')}/></td>
                                </tr>

                            </tbody>
                        </table>

                        {/* Slack div to send messages */}
                        <div className='py-3'>
                            <button className='btn btn-primary' disabled={this.state.sendingToSlack} onClick={() => this.sendToSlack()}>Notify Office for Review</button>
                        </div>
                        <div className={this.state.slackResponse !== '' ? 'py-3' : 'd-none'}>
                            <p className='text-white'>{this.state.slackResponse}</p>
                        </div>
                        <div className={this.state.sendingToSlack ? 'py-3' : 'd-none'}>
                            <div className={css.PhotoPack__Loader}></div>
                        </div>
                    </div>
                }

                <h2 className={this.state.errorMessage !== '' ? 'text-error' : 'd-none'}>Error: {this.state.errorMessage}</h2>

            </div>
        )
    }
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(MPUPhotoPack);